define("settings/components/cluster/social-profile-refresh", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/utils/constants", "shared/utils/redirect", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _computed, _service, _component2, _tracking, _emberConcurrency, _constants, _redirect, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/constants",0,"shared/utils/redirect",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#unless this.isDisabledTwitter}}
    <div class="o--btnGroup--block tAC--table__btnGroup" data-test-id="social-profile-refresh">
      {{#if @socialProfileState.action.showOnlyEdit}}
        {{! Placeholder btn to push Edit button to right }}
        <div class="o--btn o--btn--disabled"></div>
      {{else}}
        {{#if this.isRefreshing}}
          <Shared::Ui::Button @isDisabled={{true}} @text={{t "shared_words.refreshing"}} @variant="outline" />
        {{else if @socialProfileState.action.isConnectBusiness}}
          <Shared::Credentials::UpgradeButton
            @buttonClass={{@socialProfileState.action.class}}
            @buttonText={{@socialProfileState.action.title}}
            @path="account.groups.group"
            @socialProfile={{@socialProfile}}
          />
        {{else}}
          <Shared::Ui::Button
            @class={{concat-classes
              "qa--socialProfile_refresh_btn"
              @socialProfileState.action.class
              (if @socialProfile.isInstagram "at--autoPublish__socialProfileRefresh")
            }}
            @onClick={{perform this.handleAction @socialProfileState.action.isRefreshToken}}
            @text={{@socialProfileState.action.title}}
            @variant="outline"
            data-social-profile-refresh-id="profile-refresh-button"
            title={{@socialProfile.errorText}}
          />
        {{/if}}
      {{/if}}
      <LinkTo
        @model={{@socialProfile.id}}
        @route="groups.group.social_profiles.edit"
        class="o--btn o--btn--outline"
        data-social-profile-refresh-id="profile-refresh-edit"
      >
        {{t "shared_words.edit"}}
      </LinkTo>
    </div>
  {{/unless}}
  
  {{#if this.showTiktokRefreshConfirmationModal}}
    <Shared::Credentials::TiktokRefreshConfirm
      @handleClose={{set this "showTiktokRefreshConfirmationModal" false}}
      @refreshUnverifiedTiktok={{action "refreshUnverifiedTiktok"}}
    />
  {{/if}}
  */
  {
    "id": "WpaF8kNI",
    "block": "[[[41,[51,[30,0,[\"isDisabledTwitter\"]]],[[[1,\"  \"],[10,0],[14,0,\"o--btnGroup--block tAC--table__btnGroup\"],[14,\"data-test-id\",\"social-profile-refresh\"],[12],[1,\"\\n\"],[41,[30,1,[\"action\",\"showOnlyEdit\"]],[[[1,\"      \"],[10,0],[14,0,\"o--btn o--btn--disabled\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isRefreshing\"]],[[[1,\"        \"],[8,[39,2],null,[[\"@isDisabled\",\"@text\",\"@variant\"],[true,[28,[37,3],[\"shared_words.refreshing\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],[[[41,[30,1,[\"action\",\"isConnectBusiness\"]],[[[1,\"        \"],[8,[39,4],null,[[\"@buttonClass\",\"@buttonText\",\"@path\",\"@socialProfile\"],[[30,1,[\"action\",\"class\"]],[30,1,[\"action\",\"title\"]],\"account.groups.group\",[30,2]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,2],[[24,\"data-social-profile-refresh-id\",\"profile-refresh-button\"],[16,\"title\",[30,2,[\"errorText\"]]]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[28,[37,5],[\"qa--socialProfile_refresh_btn\",[30,1,[\"action\",\"class\"]],[52,[30,2,[\"isInstagram\"]],\"at--autoPublish__socialProfileRefresh\"]],null],[28,[37,6],[[30,0,[\"handleAction\"]],[30,1,[\"action\",\"isRefreshToken\"]]],null],[30,1,[\"action\",\"title\"]],\"outline\"]],null],[1,\"\\n      \"]],[]]]],[]]]],[]]],[1,\"    \"],[8,[39,7],[[24,0,\"o--btn o--btn--outline\"],[24,\"data-social-profile-refresh-id\",\"profile-refresh-edit\"]],[[\"@model\",\"@route\"],[[30,2,[\"id\"]],\"groups.group.social_profiles.edit\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"shared_words.edit\"],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showTiktokRefreshConfirmationModal\"]],[[[1,\"  \"],[8,[39,8],null,[[\"@handleClose\",\"@refreshUnverifiedTiktok\"],[[28,[37,9],[[30,0],\"showTiktokRefreshConfirmationModal\",false],null],[28,[37,10],[[30,0],\"refreshUnverifiedTiktok\"],null]]],null],[1,\"\\n\"]],[]],null]],[\"@socialProfileState\",\"@socialProfile\"],false,[\"unless\",\"if\",\"shared/ui/button\",\"t\",\"shared/credentials/upgrade-button\",\"concat-classes\",\"perform\",\"link-to\",\"shared/credentials/tiktok-refresh-confirm\",\"set\",\"action\"]]",
    "moduleName": "settings/components/cluster/social-profile-refresh.hbs",
    "isStrictMode": false
  });

  /**
   * @class SocialProfileRefresh
   * @extends Component
   */
  let SocialProfileRefreshComponent = _exports.default = (_dec = (0, _service.inject)('social/connect-profiles'), _dec2 = (0, _service.inject)('social/facebook-auth'), _dec3 = (0, _service.inject)('social/instagram-auth'), _dec4 = (0, _computed.reads)('auth.currentUserModel'), _dec5 = (0, _computed.reads)('currentUserModel.admin'), _dec6 = (0, _computed.alias)('laterConfig.facebookAppId'), _dec7 = (0, _computed.filterBy)('auth.socialProfiles', 'isFacebook', true), _dec8 = (0, _computed.and)('args.socialProfile.isProfessional', 'args.socialProfile.hasProfessionalAccount'), (_class = class SocialProfileRefreshComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "laterConfig", _descriptor3, this);
      // Used in CredentialsNotFoundError
      // eslint-disable-next-line ember/no-unused-services
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "tiktok", _descriptor5, this);
      _initializerDefineProperty(this, "connectProfiles", _descriptor6, this);
      _initializerDefineProperty(this, "facebookAuth", _descriptor7, this);
      _initializerDefineProperty(this, "instagramAuth", _descriptor8, this);
      _initializerDefineProperty(this, "showTiktokRefreshConfirmationModal", _descriptor9, this);
      _initializerDefineProperty(this, "currentUserModel", _descriptor10, this);
      _initializerDefineProperty(this, "isAdmin", _descriptor11, this);
      _initializerDefineProperty(this, "facebookAppId", _descriptor12, this);
      _initializerDefineProperty(this, "facebookProfiles", _descriptor13, this);
      _initializerDefineProperty(this, "isProfessional", _descriptor14, this);
      _defineProperty(this, "handleAction", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const {
            socialProfile
          } = this.args;
          try {
            if (socialProfile.isInstagram && !socialProfile.isInstagramLogin) {
              yield this.instagramAuth.authenticateWithFacebookGraphApi.perform({
                refreshSocialProfiles: [socialProfile]
              });

              // Note: if refresh fails, open Instagram Auth Status Modal
              if (socialProfile.needsRefresh) {
                this.args.openInstagramAuthStatus();
              }
            } else if (socialProfile.isFacebook) {
              yield this.facebookAuth.authenticate.perform({
                refreshSocialProfile: socialProfile
              });
            } else if (socialProfile.isTiktok) {
              if ((socialProfile.isTiktokUnverifiedAccount || socialProfile.isTiktokLoginKitAccount) && socialProfile.canConnectTiktokApi) {
                this.showTiktokRefreshConfirmationModal = true;
              } else {
                this.tiktok.refresh(socialProfile, `account/groups/${this.auth.currentGroup.id}/social_profiles/`);
              }
            } else {
              let oAuthPath;
              const groupSlug = socialProfile.get('group.slug');
              if (socialProfile.isTwitter) {
                oAuthPath = this.connectProfiles.oAuthPath({
                  socialProfileType: _constants.OauthSocialProfileType.Twitter,
                  redirectGroupSlug: groupSlug
                });
              } else if (socialProfile.isPinterest) {
                oAuthPath = this.connectProfiles.oAuthPath({
                  socialProfileType: _constants.OauthSocialProfileType.Pinterest,
                  redirectGroupSlug: groupSlug
                });
              } else if (socialProfile.isLinkedin) {
                oAuthPath = this.connectProfiles.oAuthPath({
                  socialProfileType: _constants.OauthSocialProfileType.Linkedin,
                  redirectGroupSlug: groupSlug
                });
              } else if (socialProfile.isYoutube) {
                oAuthPath = this.connectProfiles.oAuthPath({
                  socialProfileType: _constants.OauthSocialProfileType.Youtube,
                  redirectGroupSlug: groupSlug
                });
              } else if (socialProfile.isThreads) {
                oAuthPath = this.connectProfiles.oAuthPath({
                  socialProfileType: _constants.OauthSocialProfileType.Threads,
                  redirectGroupSlug: groupSlug
                });
              } else if (socialProfile.isSnapchat) {
                oAuthPath = this.connectProfiles.oAuthPath({
                  socialProfileType: _constants.OauthSocialProfileType.Snapchat,
                  redirectGroupSlug: groupSlug
                });
              } else if (socialProfile.isInstagram) {
                oAuthPath = this.connectProfiles.oAuthPath({
                  socialProfileType: _constants.OauthSocialProfileType.Instagram,
                  redirectGroupSlug: groupSlug,
                  redirectPath: `account/groups/${groupSlug}/social_profiles/`
                });
              }
              if (oAuthPath) {
                const params = `group_id=${socialProfile.get('group.id')}&refresh_social_profile_id=${socialProfile.id}`;
                (0, _redirect.default)(`${oAuthPath}&${params}`);
              }
            }
          } catch (error) {
            this.errors.show(error);
          }
        }
      }), null, "handleAction", "drop"));
    }
    get isDisabledTwitter() {
      return Boolean(this.auth.currentAccount?.rolloutTwitterSunset && this.args.socialProfile.isTwitter);
    }
    refreshUnverifiedTiktok() {
      this.tiktok.refresh(this.args.socialProfile);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "laterConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "tiktok", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "connectProfiles", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "facebookAuth", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "instagramAuth", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "showTiktokRefreshConfirmationModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "currentUserModel", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isAdmin", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "facebookAppId", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "facebookProfiles", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "isProfessional", [_dec8], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "refreshUnverifiedTiktok", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshUnverifiedTiktok"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialProfileRefreshComponent);
});